"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModel = exports.getGlobalModel = exports.getGlobalFactoryModel = exports.getPendingModel = exports.getScriptTag = void 0;
var editor_elements_conventions_1 = require("@wix/editor-elements-conventions");
var RegistryError_1 = require("../errors/RegistryError");
var flags_1 = require("../flags");
var evaluateBundle_1 = require("./evaluateBundle");
var SCRIPT_LOADING_TIME_THRESHOLD = 10000;
function getScriptTag(url) {
    if (!flags_1.isBrowserMainThread) {
        return null;
    }
    var element = document.querySelector("script[src=\"" + url + "\"]");
    return element;
}
exports.getScriptTag = getScriptTag;
function getPendingModel(_a) {
    var _this = this;
    var id = _a.id, url = _a.url;
    var element = getScriptTag(url);
    if (element) {
        return new Promise(function (resolve, reject) {
            var isOnLoadCalled = false;
            element.addEventListener('load', function () { return __awaiter(_this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            isOnLoadCalled = true;
                            if (!id) return [3 /*break*/, 2];
                            _a = resolve;
                            return [4 /*yield*/, getGlobalModel(id)];
                        case 1:
                            _a.apply(void 0, [_b.sent()]);
                            return [3 /*break*/, 3];
                        case 2:
                            resolve();
                            _b.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); });
            /**
             * In general, this case should never happen.
             * If `addEventListener` was added on the already loaded script tag –
             * callback never will be called, which means that `getPendingModel()` function is never resolved.
             */
            setTimeout(function () {
                if (!isOnLoadCalled) {
                    var error = RegistryError_1.createException('`getModel` is not resolved')
                        .withUrl(url)
                        .withHint('probably, event listener was added on already loaded script');
                    reject(error.message);
                }
            }, SCRIPT_LOADING_TIME_THRESHOLD);
        });
    }
    return null;
}
exports.getPendingModel = getPendingModel;
function getGlobalFactoryModel(id) {
    return __awaiter(this, void 0, void 0, function () {
        var factory;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getGlobalModel(editor_elements_conventions_1.getLazyFactoryID(id))];
                case 1:
                    factory = _a.sent();
                    if (factory && !factory.invoked) {
                        factory.invoked = true;
                        factory();
                    }
                    /**
                     * Probably we need to check pending script tags
                     */
                    return [2 /*return*/, getGlobalModel(id)];
            }
        });
    });
}
exports.getGlobalFactoryModel = getGlobalFactoryModel;
function getGlobalModel(id) {
    var env = evaluateBundle_1.getEnvironment({ id: id });
    var model = env.self[id];
    if (!model && typeof env.define === 'function') {
        return evaluateBundle_1.requireAMDModule(id);
    }
    return model;
}
exports.getGlobalModel = getGlobalModel;
function getModel(id, url) {
    return __awaiter(this, void 0, void 0, function () {
        var model;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getGlobalModel(id)];
                case 1:
                    model = _a.sent();
                    if (model) {
                        return [2 /*return*/, model];
                    }
                    return [2 /*return*/, getPendingModel({ id: id, url: url })];
            }
        });
    });
}
exports.getModel = getModel;
//# sourceMappingURL=getModel.js.map